/** Azerbaijani react-admin UI strings (subset matching ru.ts). */
export const azRa = {
  action: {
    add: "Əlavə et",
    add_filter: "Filtr əlavə et",
    back: "Geri",
    bulk_actions: "1 seçildi |||| %{smart_count} seçildi",
    cancel: "Ləğv et",
    clear_input_value: "Təmizlə",
    clone: "Kopyala",
    confirm: "Təsdiqlə",
    create: "Yarat",
    create_item: "%{item} yarat",
    delete: "Sil",
    edit: "Redaktə et",
    export: "İxrac",
    list: "Siyahı",
    refresh: "Yenilə",
    remove: "Sil",
    remove_filter: "Filtrı sil",
    remove_all_filters: "Bütün filtrləri sil",
    save: "Saxla",
    search: "Axtar",
    select_all: "Hamısını seç",
    select_row: "Sətri seç",
    show: "Aç",
    sort: "Sırala",
    undo: "Geri al",
    unselect: "Seçimi ləğv et",
    expand: "Aç",
    close: "Bağla",
    open_menu: "Menunu aç",
    close_menu: "Menunu bağla",
    update: "Yenilə",
    move_up: "Yuxarı",
    move_down: "Aşağı",
    open: "Aç",
    toggle_theme: "Temanı dəyiş",
    select_columns: "Sütunlar",
  },
  boolean: { true: "Bəli", false: "Xeyr", null: " " },
  page: {
    create: "%{name} yarat",
    dashboard: "Panel",
    edit: "%{name} #%{id}",
    error: "Xəta",
    list: "%{name}",
    loading: "Yüklənir",
    not_found: "Tapılmadı",
    show: "%{name} #%{id}",
    empty: "Qeyd yoxdur",
    invite: "İlkini yaratmaq istəyirsiniz?",
  },
  input: {
    file: { upload_several: "Faylları sürüşdürün və ya klikləyin", upload_single: "Faylı sürüşdürün və ya klikləyin" },
    image: {
      upload_several: "Şəkilləri sürüşdürün və ya klikləyin",
      upload_single: "Şəkili sürüşdürün və ya klikləyin",
    },
    references: {
      all_missing: "Əlaqəli qeydlər tapılmadı",
      many_missing: "Bəzi qeydlər tapılmadı",
      single_missing: "Əlaqəli qeyd tapılmadı",
    },
    password: { toggle_visible: "Göstər", toggle_hidden: "Gizlət" },
  },
  message: {
    about: "Haqqında",
    are_you_sure: "Əminsiniz?",
    bulk_delete_content: "%{name} silinsin? |||| %{smart_count} qeyd silinsin?",
    bulk_delete_title: "%{name} sil |||| %{smart_count} qeyd sil",
    bulk_update_content: "%{name} dəyişdirilsin? |||| %{smart_count} qeyd dəyişdirilsin?",
    bulk_update_title: "%{name} dəyişdir |||| %{smart_count} qeyd dəyişdir",
    delete_content: "Qeyd silinsin?",
    delete_title: "%{name} #%{id} sil",
    details: "Detallar",
    error: "Xəta baş verdi, əməliyyat yerinə yetirilmədi",
    invalid_form: "Formada səhvlər var",
    loading: "Yüklənir...",
    no: "Xeyr",
    not_found: "Qeyd tapılmadı",
    yes: "Bəli",
    unsaved_changes: "Saxlanmamış dəyişikliklər var. Çıxılsın?",
  },
  navigation: {
    no_results: "Nəticə tapılmadı",
    no_more_results: "Bu son səhifədir",
    page_out_of_boundaries: "Səhifə %{page} diapazondan kənardadır",
    page_out_from_end: "Siyahının sonu",
    page_out_from_begin: "Siyahının əvvəli",
    page_range_info: "%{offsetBegin}-%{offsetEnd} / %{total}",
    page_rows_per_page: "Səhifədə:",
    next: "Növbəti",
    prev: "Əvvəlki",
    previous: "Əvvəlki",
    skip_nav: "Məzmuna keç",
  },
  sort: { sort_by: "%{field} %{order} sırala", ASC: "artan", DESC: "azalan" },
  auth: {
    auth_check_error: "Avtorizasiya tələb olunur",
    user_menu: "Profil",
    username: "E-poçt və ya telefon",
    password: "Şifrə",
    sign_in: "Daxil ol",
    sign_in_error: "Avtorizasiya xətası",
    logout: "Çıxış",
  },
  notification: {
    updated: "Saxlanıldı |||| %{smart_count} qeyd yeniləndi",
    created: "Yaradıldı",
    deleted: "Silindi |||| %{smart_count} qeyd silindi",
    bad_item: "Yanlış qeyd",
    item_doesnt_exist: "Qeyd mövcud deyil",
    http_error: "Server xətası",
    data_provider_error: "Server xətası",
    i18n_error: "Tərcümə yüklənmədi",
    canceled: "Ləğv edildi",
    logged_out: "Sessiya bitdi, yenidən daxil olun",
    not_authorized: "Bu əməliyyat üçün icazə yoxdur",
  },
  validation: {
    required: "Məcburi sahə",
    minLength: "Minimum %{min} simvol",
    maxLength: "Maksimum %{max} simvol",
    minValue: "Minimum %{min}",
    maxValue: "Maksimum %{max}",
    number: "Rəqəm olmalıdır",
    email: "Yanlış e-poçt",
    oneOf: "Mümkün: %{options}",
    regex: "Format uyğun deyil: %{pattern}",
  },
  saved_queries: {
    label: "Saxlanmış axtarışlar",
    query_name: "Ad",
    new_label: "Saxla...",
    new_dialog_title: "Axtarışı saxla",
    remove_label: "Sil",
    remove_label_with_name: "%{name} sil",
    remove_dialog_title: "Silinsin?",
  },
  configurable: { customize: "Fərdiləşdir" },
};
